module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-14.9ce3ef4a.svg";